import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class PhoneSerializer extends BaseSerializer {
  deserialize(raw, { phoneNumber }) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200;
    if (!success) {
      let message = 'invalid';
      if (serverRes.statusCode == 404) {
        message = 'réseau inconnu';
      }
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message,
        data: null
      };
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Got',
      data: {
        id: serverRes.data?.id,
        carrier: serverRes.data?.carrier,
        isValid: serverRes.data?.isValid,
        countryCode: serverRes.data?.countryCode,
        nationalNumber: serverRes.data?.nationalNumber,
        countryCallingCode: serverRes.data?.countryCallingCode,
        internationalNumber: serverRes.data?.internationalNumber
      }
    };
  }

  serialize() {}
}

export const serializer = new PhoneSerializer();
